'use client';

import {
  QueryClient,
  QueryClientProvider,
  keepPreviousData,
} from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      placeholderData: keepPreviousData,
    },
  },
});

export const invalidateQueries = (key: string) => {
  queryClient.invalidateQueries({ queryKey: [key] });
};

export const invalidateUser = () => {
  invalidateQueries('users-me');
};

export const QueryProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
  );
};
